import { render, staticRenderFns } from "./CookiesEn.vue?vue&type=template&id=c7e35042"
import script from "./CookiesEn.vue?vue&type=script&lang=js"
export * from "./CookiesEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports